'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks, type BuilderElement } from '@builder.io/react';
import appStoreLogoEn from '@public/images/app_store.svg';
import appStoreLogoFr from '@public/images/app_store_fr.svg';
import googlePlayLogoEn from '@public/images/google_play.svg';
import googlePlayLogoFr from '@public/images/google_play_fr.svg';
import { uniqueId } from 'lodash';
import Image from 'next/image';
import Link from 'next/link';
import { ampli } from '@src/ampli-web';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useTrackSelectCta } from '@src/utils/analytics.util';
import { Container } from '../Container/Container';
import { LocaleSwitcher } from '../LocaleSwitcher/LocaleSwitcher';
import facebookImg from './assets/facebook.svg';
import instagramImg from './assets/instagram.svg';
import faqIcon from './assets/question.svg';
import youtubeImg from './assets/youtube.svg';
interface certImage {
  imageUrl: string;
  alt: string;
}
interface BigFooterProps {
  builderBlock?: any;
  columns: BuilderElement[];
  disclaimers: BuilderElement[];
  appStoreUrl: string;
  googlePlayUrl: string;
  instagramUrl: string;
  facebookUrl: string;
  youtubeUrl: string;
  faqUrl: string;
  faqText: string;
  certificateBadges?: certImage[];
}
export const BigFooter = props => {
  const $ = _c(95);
  const {
    columns,
    disclaimers,
    builderBlock,
    faqText,
    faqUrl: t0,
    appStoreUrl: t1,
    facebookUrl: t2,
    googlePlayUrl: t3,
    instagramUrl: t4,
    youtubeUrl: t5,
    certificateBadges: t6
  } = props;
  const faqUrl = t0 === undefined ? "" : t0;
  const appStoreUrl = t1 === undefined ? "" : t1;
  const facebookUrl = t2 === undefined ? "" : t2;
  const googlePlayUrl = t3 === undefined ? "" : t3;
  const instagramUrl = t4 === undefined ? "" : t4;
  const youtubeUrl = t5 === undefined ? "" : t5;
  let t7;
  if ($[0] !== t6) {
    t7 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const certificateBadges = t7;
  const trackSelectCta = useTrackSelectCta();
  const {
    locale
  } = useLocale();
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      en: appStoreLogoEn,
      fr: appStoreLogoFr
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const appStoreLogo = t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      en: googlePlayLogoEn,
      fr: googlePlayLogoFr
    };
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const googlePlayLogo = t9;
  let t10;
  if ($[4] !== faqUrl || $[5] !== trackSelectCta) {
    t10 = () => {
      trackSelectCta({
        "cta url": faqUrl
      });
      ampli.flush();
    };
    $[4] = faqUrl;
    $[5] = trackSelectCta;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Image src={faqIcon} width={20} height={20} alt="Faq" />;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== faqText) {
    t12 = <div className="mb-8 flex gap-2 hover:underline">{t11}<p className="text-body-md">{faqText}</p></div>;
    $[8] = faqText;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== faqUrl || $[11] !== t10 || $[12] !== t12) {
    t13 = <LocalizedLink href={faqUrl} className="lg:hidden" onClick={t10}>{t12}</LocalizedLink>;
    $[10] = faqUrl;
    $[11] = t10;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const t14 = appStoreLogo[locale.lang];
  let t15;
  if ($[14] !== appStoreUrl || $[15] !== trackSelectCta) {
    t15 = () => {
      trackSelectCta({
        "cta url": appStoreUrl
      });
      ampli.flush();
    };
    $[14] = appStoreUrl;
    $[15] = trackSelectCta;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t14 || $[18] !== t15) {
    t16 = <Image className="h-[41px]" src={t14} width={120} height={40} alt="App Store" onClick={t15} />;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== appStoreUrl || $[21] !== t16) {
    t17 = <Link href={appStoreUrl} className="shrink-0">{t16}</Link>;
    $[20] = appStoreUrl;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  const t18 = googlePlayLogo[locale.lang];
  let t19;
  if ($[23] !== googlePlayUrl || $[24] !== trackSelectCta) {
    t19 = () => {
      trackSelectCta({
        "cta url": googlePlayUrl
      });
      ampli.flush();
    };
    $[23] = googlePlayUrl;
    $[24] = trackSelectCta;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t18 || $[27] !== t19) {
    t20 = <Image className="h-[40px]" src={t18} width={135} height={40} alt="Google Play" onClick={t19} />;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== googlePlayUrl || $[30] !== t20) {
    t21 = <Link href={googlePlayUrl} className="shrink-0">{t20}</Link>;
    $[29] = googlePlayUrl;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t17 || $[33] !== t21) {
    t22 = <div className="flex gap-6">{t17}{t21}</div>;
    $[32] = t17;
    $[33] = t21;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== instagramUrl || $[36] !== trackSelectCta) {
    t23 = () => {
      trackSelectCta({
        "cta url": instagramUrl
      });
      ampli.flush();
    };
    $[35] = instagramUrl;
    $[36] = trackSelectCta;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Image src={instagramImg} width={36} height={36} alt="Instagram" />;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== instagramUrl || $[40] !== t23) {
    t25 = <Link href={instagramUrl} onClick={t23}>{t24}</Link>;
    $[39] = instagramUrl;
    $[40] = t23;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== facebookUrl || $[43] !== trackSelectCta) {
    t26 = () => {
      trackSelectCta({
        "cta url": facebookUrl
      });
      ampli.flush();
    };
    $[42] = facebookUrl;
    $[43] = trackSelectCta;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Image src={facebookImg} width={36} height={36} alt="Facebook" />;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] !== facebookUrl || $[47] !== t26) {
    t28 = <Link href={facebookUrl} onClick={t26}>{t27}</Link>;
    $[46] = facebookUrl;
    $[47] = t26;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== trackSelectCta || $[50] !== youtubeUrl) {
    t29 = () => {
      trackSelectCta({
        "cta url": youtubeUrl
      });
      ampli.flush();
    };
    $[49] = trackSelectCta;
    $[50] = youtubeUrl;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Image src={youtubeImg} width={36} height={36} alt="Youtube" />;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== t29 || $[54] !== youtubeUrl) {
    t31 = <Link href={youtubeUrl} onClick={t29}>{t30}</Link>;
    $[53] = t29;
    $[54] = youtubeUrl;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] !== t25 || $[57] !== t28 || $[58] !== t31) {
    t32 = <div className="flex gap-6">{t25}{t28}{t31}</div>;
    $[56] = t25;
    $[57] = t28;
    $[58] = t31;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== faqUrl || $[61] !== trackSelectCta) {
    t33 = () => {
      trackSelectCta({
        "cta url": faqUrl
      });
      ampli.flush();
    };
    $[60] = faqUrl;
    $[61] = trackSelectCta;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  let t34;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Image src={faqIcon} width={20} height={20} alt="Faq" />;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== faqText) {
    t35 = <div className="flex gap-2 hover:underline">{t34}<p className="text-body-md">{faqText}</p></div>;
    $[64] = faqText;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] !== faqUrl || $[67] !== t33 || $[68] !== t35) {
    t36 = <LocalizedLink href={faqUrl} className="hidden lg:block" onClick={t33}>{t35}</LocalizedLink>;
    $[66] = faqUrl;
    $[67] = t33;
    $[68] = t35;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  let t37;
  if ($[70] !== t22 || $[71] !== t32 || $[72] !== t36) {
    t37 = <div className="mb-14 flex flex-wrap items-center justify-between gap-8 border-b border-bodi-gray-butters pb-14">{t22}{t32}{t36}</div>;
    $[70] = t22;
    $[71] = t32;
    $[72] = t36;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] !== builderBlock?.id || $[75] !== columns) {
    t38 = columns?.map((item, index) => <BuilderBlocks key={uniqueId()} child={true} parentElementId={builderBlock?.id} dataPath={`component.options.columns.${index}.column`} blocks={item?.column} />);
    $[74] = builderBlock?.id;
    $[75] = columns;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== t38) {
    t39 = <div className="mb-14 grid grid-cols-2 gap-8 border-b border-bodi-gray-butters pb-14 lg:grid-cols-4">{t38}</div>;
    $[77] = t38;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== builderBlock?.id || $[80] !== disclaimers) {
    t40 = disclaimers?.map((item_0, index_0) => <BuilderBlocks key={uniqueId()} child={true} parentElementId={builderBlock?.id} dataPath={`component.options.disclaimers.${index_0}.disclaimer`} blocks={item_0?.disclaimer} />);
    $[79] = builderBlock?.id;
    $[80] = disclaimers;
    $[81] = t40;
  } else {
    t40 = $[81];
  }
  let t41;
  if ($[82] !== t40) {
    t41 = <div className="flex">{t40}</div>;
    $[82] = t40;
    $[83] = t41;
  } else {
    t41 = $[83];
  }
  let t42;
  if ($[84] !== certificateBadges) {
    t42 = certificateBadges?.map(_temp);
    $[84] = certificateBadges;
    $[85] = t42;
  } else {
    t42 = $[85];
  }
  let t43;
  if ($[86] !== t42) {
    t43 = <div className="mt-4 flex justify-start lg:justify-end"><div className="flex h-14 shrink-0 grow-0 flex-row gap-2">{t42}</div></div>;
    $[86] = t42;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="mt-4 -ml-4"><LocaleSwitcher /></div>;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  let t45;
  if ($[89] !== t13 || $[90] !== t37 || $[91] !== t39 || $[92] !== t41 || $[93] !== t43) {
    t45 = <footer className="bg-bodi-gray-pearl py-12"><Container>{t13}{t37}{t39}{t41}{t43}{t44}</Container></footer>;
    $[89] = t13;
    $[90] = t37;
    $[91] = t39;
    $[92] = t41;
    $[93] = t43;
    $[94] = t45;
  } else {
    t45 = $[94];
  }
  return t45;
};
function _temp(item_1) {
  return <Image key={uniqueId()} src={item_1.imageUrl} width={150} alt={item_1.alt} height={50} className="object-contain" />;
}